import React from "react";
import Hero from "../Hero";
import Beneficios from "../Beneficios";
import Galeria from "../Galeria";
import AmenitiesInfra from "../AmenitiesInfra";
import DetallesProyecto from "../DetallesProyecto";
import PromocionLimitada from "../PromocionLimitada";
import UbicacionProyecto from "../UbicacionProyecto";
import SubFooter from "../SubFooter";

const Home = () => {
  return (
    <>
      <Hero />
      <Beneficios />
      <Galeria />
      <AmenitiesInfra />
      <DetallesProyecto />
      <PromocionLimitada />
      <UbicacionProyecto />
      <SubFooter />
    </>
  );
};

export default Home;
